import { type ReactElement } from 'react';
import { landingRoute } from '../../src/index';
import { useAdmin } from '../session';
import { useRouter } from '../router';
import { useT } from '../i18n/provider';
import { Button, Measure, PageHeader, Stack, Text, UiIcon } from '@vello/web-theme';

/**
 * An address no screen owns (D854, L7a-020): it used to render the dashboard under the wrong URL. This says so in words, inside the
 * normal console chrome, and offers one way out - the first screen this operator's access opens.
 */
export function NotFoundScreen(): ReactElement {
  const { grants } = useAdmin();
  const { navigate } = useRouter();
  const { t } = useT();
  return (
    <>
      <PageHeader title={t('notfound.title')} />
      <Stack gap={2} align="center" className="vello-placeholder">
        <span className="vello-empty__mark vello-admin-a-bigmark">
          <UiIcon name="searchX" size={22} />
        </span>
        <Measure size="md"><Text as="div" role="caption">{t('notfound.body')}</Text></Measure>
        <Button variant="primary" onClick={() => navigate(landingRoute(grants))}>{t('access.back')}</Button>
      </Stack>
    </>
  );
}
